import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "decoration-card__name" }
const _hoisted_3 = {
  key: 0,
  class: "decoration-card__landing-page-link"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "decoration-card__area"
}

import { computed } from '@vue/reactivity';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*@__PURE__*/_defineComponent({
  __name: 'DecorationCard',
  props: {
  decoration: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
},
  emits: ['selected', 'selectedValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { websiteText } = useWebsiteTexts();

function selectPlacement(id: string, value: string) {
  emit('selected', id);
  emit('selectedValue', value);
}

const lowercaseName = computed(
  () => props.decoration.name?.toLowerCase() || ''
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    key: __props.decoration.id,
    class: _normalizeClass(['decoration-card', { 'decoration-card--selected': __props.selected }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (selectPlacement(__props.decoration.id, __props.decoration.value)))
  }, [
    _createElementVNode("img", {
      class: "decoration-card__image",
      src: __props.decoration.url,
      alt: __props.decoration.name
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(lowercaseName)), 1),
    (
        __props.decoration.landingPageLinkUrl !== undefined &&
        __props.decoration.landingPageLinkUrl !== ''
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("a", {
            href: __props.decoration.landingPageLinkUrl,
            target: "_blank"
          }, _toDisplayString(_unref(websiteText)('decoration__print-example').value), 9, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    (__props.decoration.area)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.decoration.area), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})